var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5009_35542)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2459 4.09871C12.5924 4.26523 12.8127 4.6156 12.8127 5.00001V19C12.8127 19.3844 12.5924 19.7348 12.2459 19.9013C11.8995 20.0678 11.4882 20.021 11.188 19.7809L6.46196 16H2.81274C2.26046 16 1.81274 15.5523 1.81274 15V9.00001C1.81274 8.44772 2.26046 8.00001 2.81274 8.00001H6.46196L11.188 4.21914C11.4882 3.979 11.8995 3.93219 12.2459 4.09871ZM10.8127 7.08063L7.43744 9.78088C7.26013 9.92273 7.03982 10 6.81274 10H3.81274V14H6.81274C7.03982 14 7.26013 14.0773 7.43744 14.2191L10.8127 16.9194V7.08063Z",
    fill: "#FB7B34"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5199 8.2929C24.9104 8.68343 24.9104 9.31659 24.5199 9.70712L18.5199 15.7071C18.1293 16.0976 17.4962 16.0976 17.1056 15.7071C16.7151 15.3166 16.7151 14.6834 17.1056 14.2929L23.1056 8.2929C23.4962 7.90238 24.1293 7.90238 24.5199 8.2929Z",
    fill: "#FB7B34"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1056 8.2929C17.4962 7.90238 18.1293 7.90238 18.5199 8.2929L24.5199 14.2929C24.9104 14.6834 24.9104 15.3166 24.5199 15.7071C24.1293 16.0976 23.4962 16.0976 23.1056 15.7071L17.1056 9.70712C16.7151 9.31659 16.7151 8.68343 17.1056 8.2929Z",
    fill: "#FB7B34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5009_35542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.812744)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.c65c385e73a7a4070aecc5e026d2cd26.svg";
export { ForwardRef as ReactComponent };